import React, { useState } from "react";
import { Box, MenuItem } from "@mui/material";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, Check as CheckIcon } from "@mui/icons-material";
import colors from "../themes/colors";
import useTranslation, { SupportedLanguage } from "../hooks/useTranslation";
import { dt } from "../themes/redesignTokens";
import customersApi from "../../customer/shared/api/customersApi";

const LanguageMenuItem: React.FC = () => {
  const { changeLanguage, getCurrentLanguage, getSupportedLanguages, translate } = useTranslation("common");
  const [expandLanguages, setExpandLanguages] = useState<boolean>(false);

  const handleLanguageMenuClick = () => {
    setExpandLanguages(!expandLanguages);
  };

  const handleLanguageSelect = (lng: SupportedLanguage) => {
    changeLanguage(lng);
    customersApi.updateLanguage(lng).catch(() => {
      // silent -- localStorage (i18nextLng) is the fallback
    });
    setExpandLanguages(false);
  };

  const getLanguageDisplayName = (lng: SupportedLanguage): string => {
    const names: Record<SupportedLanguage, string> = {
      sk: "Slovenčina",
      en: "English",
      cs: "Čeština"
    };
    return names[lng];
  };

  const currentLanguage = getCurrentLanguage();

  return (
    <>
      <MenuItem
        className="px-4 py-2"
        sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
        onClick={handleLanguageMenuClick}
      >
        <Box className="text-18-regular" color={colors.secondary.gray20}>
          {translate("common.language")}
        </Box>
        <Box className="ml-2">
          {expandLanguages ? (
            <ExpandLessIcon sx={{ color: colors.secondary.gray20 }} />
          ) : (
            <ExpandMoreIcon sx={{ color: colors.secondary.gray20 }} />
          )}
        </Box>
      </MenuItem>

      {expandLanguages && (
        <Box className="px-4 py-2">
          {getSupportedLanguages().map((lng) => (
            <Box
              key={lng}
              className="px-4 py-2 cursor-pointer"
              sx={{
                "&:not(:first-of-type)": {
                  borderTop: `1px solid ${colors.secondary.gray90}`
                },
                "&:hover": {
                  backgroundColor: colors.secondary.gray96
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
              onClick={() => handleLanguageSelect(lng)}
            >
              <Box
                className="text-18-regular"
                color={lng === currentLanguage ? dt.blue : colors.secondary.gray20}
              >
                {getLanguageDisplayName(lng)}
              </Box>
              {lng === currentLanguage && (
                <CheckIcon
                  sx={{
                    color: dt.blue,
                    fontSize: "18px"
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default LanguageMenuItem; 